import { render, staticRenderFns } from "./appstore2.vue?vue&type=template&id=37450e9e&"
import script from "./appstore2.vue?vue&type=script&lang=js&"
export * from "./appstore2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports